<template>
  <div class="uni-mask">
    <div
      :style="{ top: offsetTop + 'px' }"
      class="uni-mask"
      @click="hide"
      @touchmove.stop.prevent="moveHandle"/>
<div
  :class="'uni-popup-' + position + ' ' + 'uni-popup-' + mode"
  :style="{paddingBottom: isIphoneX ? '20px' : ''}"
  class="uni-popup">
<div
class="ppbtn"
:class="[index === tabSelected ? 'active' : '']"
v-for="(item,index) in list"
:key="index"
@click="clickPopup(index, item)">
{{item}}
</div>
<div class="cancel-btn"></div>
      <div class="ppbtnb" @click="hide">取消</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'myPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      // top - 顶部， middle - 居中, bottom - 底部
      default: 'middle',
    },
    mode: {
      type: String,
      default: 'insert',
    },
    msg: {
      type: String,
      default: '',
    },
    h5Top: {
      type: Boolean,
      default: false,
    },
    buttonMode: {
      type: String,
      default: 'bottom',
    },
    list: {
      type: Array,
      default: () => [],
    },
    tabSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isIphoneX: false,
      offsetTop: 0,
    };
  },
  watch: {
    h5Top(newVal) {
      if (newVal) {
        this.offsetTop = 44;
      } else {
        this.offsetTop = 0;
      }
    },
  },
  created() {
    let offsetTop = 0;
    if (!this.h5Top) {
      offsetTop = 44;
    } else {
      offsetTop = 0;
    }
    this.offsetTop = offsetTop;
  },
  methods: {
    hide() {
      if (this.mode === 'insert' && this.position === 'middle') return;
      this.$emit('hidePopup');
    },
    closeMask() {
      if (this.mode === 'insert') {
        this.$emit('hidePopup');
      }
    },
    moveHandle() {},
    clickPopup(index, item) {
      this.$emit('clickPopup', index, item);
    },
  },
};
</script>
<style lang="less">
.uni-mask {
position: fixed;
z-index: 99999;
top: 0;
right: 0;
bottom: 0;
left: 0;
height: 100vh;
width: 100vw;
background-color: rgba(0, 0, 0, 0.0);
}

.uni-popup {
position: fixed;
z-index: 99999;
background-color: #ffffff;
}

.uni-popup-middle {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}

.uni-popup-middle.uni-popup-insert {
min-width: 380px;
min-height: 380px;
max-width: 100%;
max-height: 80%;
transform: translate(-50%, -65%);
background: none;
box-shadow: none;
}

.uni-popup-middle.uni-popup-fixed {
border-radius: 10px;
padding: 30px;
}

.uni-close-bottom,
.uni-close-right {
position: absolute;
bottom: -180px;
text-align: center;
border-radius: 50%;
color: #f5f5f5;
font-size: 60px;
font-weight: bold;
opacity: 0.8;
z-index: -1;
}
.uni-close-bottom {
margin: auto;
left: 0;
right: 0;
}
.uni-close-right {
right: -60px;
top: -80px;
}

.uni-close-bottom:after {
content: '';
position: absolute;
width: 0px;
border: 1px #f5f5f5 solid;
top: -200px;
bottom: 56px;
left: 50%;
transform: translate(-50%, -0%);
opacity: 0.8;
}

.uni-popup-top {
top: 0;
left: 0;
width: 100%;
height: 100px;
line-height: 100px;
text-align: center;
}

.uni-popup-bottom {
left: 0;
bottom: 0;
width: 100%;
min-height: 100px;
line-height: 100px;
text-align: center;
}
.ppbtn {
line-height: 90px;
font-size: 36px;
border-bottom: 1px solid #eeeeee;
}
.ppbtnb {
line-height: 90px;
font-size: 36px;
}

.active {
color: #ff4400;
}

.cancel-btn {
height: 10px;
width: 100vw;
background: #f5f5f5;
}
</style>
